import PropTypes from 'prop-types';

import { Box, Button, Container, Divider, Grid, Stack, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { styled } from "@mui/material/styles";

import { useResponsive } from '../../hooks/use-responsive';
import { useCountdownDate } from '../../hooks/use-countdown';
import { fDateTime } from '../../utils/format-time';
import YourRecentActivity from './YourRecentActivity';
import EmptyContent from '../../components/empty-content';

export default function DashHomeNotActiveUser({ userDetails }) {
    const { paymentDetails, subscription_status } = userDetails;
    const { paymentStatus, planName, paymentId, paymentDate } = paymentDetails || {};

    const endDate = new Date(fDateTime(userDetails?.subscription_end_date));
    const { days, hours, minutes, seconds } = useCountdownDate(new Date(endDate));
    // const endDate = new Date(subscription_end_date);

    // Get countdown data
    // const { days, hours, minutes, seconds } = useCountdownDate(endDate);


    const mdUp = useResponsive("up", "md");
    // console.log("subscription_status", days, hours, minutes, seconds )
    const CreateNew = styled(Button)(({ theme }) => ({
        backgroundColor: "#C7F760",
        color: "#1E53E8",
        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "& .icon-hover": {
            transition: "color 0.3s ease",
        },
        "&:hover": {
            backgroundColor: "#1E53E8",
            color: "#C7F760",
            "& .icon-hover": {
                color: "#FFFFFF", // Change the icon color to white on hover
            },
        },
    }));

    const chartData = {
        labels: ['Youtube', 'Telegram', 'PowerPoint', 'Other'],
        datasets: [
            {
                data: [45, 25, 20, 10], // Percentage data for each section
                backgroundColor: ['#CDFF3E', '#00E5FF', '#FFB2E6', '#FF4C4C'], // Colors for each section
                hoverBackgroundColor: ['#B6F238', '#00D1E4', '#FFA3D4', '#FF3C3C'], // Hover colors
                borderWidth: 2,
                cutout: '70%', // Inner radius for the donut chart
            },
        ],
    };

    const noData = (
        <Container sx={{ my: 10 }}>
            <EmptyContent
                filled
                title='No Data Available'

                sx={{ py: 10 }}
            />
        </Container>
    );
    return (
        <Fragment>
            {mdUp &&
                <Container
                    maxWidth={false}
                    sx={{
                        // display: "flex",
                        backgroundColor: "#B7FFFE",
                        padding: "30px 20px",
                        borderRadius: "20px",
                        // maxWidth: '600px',
                        // margin: "auto",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >

                    <Grid
                        container
                        direction={{ lg: "row", md: "row", sm: "column" }}
                        columnGap={3}
                        sx={{ alignItems: "center", justifyContent: "center", justifyItems: 'center' }}
                    >
                        <Grid item xs={3} justifyContent="center" alignItems="center">
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minWidth: "65px",
                                        maxWidth: "65px",
                                        maxHeight: "65px",
                                    }}
                                >
                                    <img
                                        src="/assets/DashActivePlan.png"
                                        alt="DashActivePlan"
                                        style={{ maxWidth: "100%" }}
                                    />
                                </Box>
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#1D53E7",
                                            fontWeight: "600",
                                            fontStyle: "italic",
                                            fontFamily: "Roboto Flex",
                                        }}
                                    >
                                        Active Plan
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: "600",
                                            fontFamily: "Sofia Sans Extra Condensed",
                                        }}
                                    >
                                        {planName} {" "} Plan
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontFamily: "Roboto Flex" }}>
                                        <span
                                            style={{
                                                fontWeight: 600,
                                                fontSize: "22px",
                                                color: userDetails?.subscription_status === "Active" ? "#27AE60" : "#FF0000",
                                            }}
                                        >
                                            ●
                                        </span>
                                        {userDetails?.subscription_status === "Active" ? " Active" : " Inactive"}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Divider
                            orientation="vertical"
                            variant="inset"
                            flexItem
                            sx={{
                                mx: 2, borderColor: '#858585',
                                bgcolor: '#858585',
                                width: '1px'
                            }}
                        />


                        <Grid item xs={3} justifyContent="center" alignItems="center">
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minWidth: "65px",
                                        maxWidth: "65px",
                                        maxHeight: "65px",
                                    }}
                                >
                                    <img
                                        src="/assets/DashValidity.png"
                                        alt="DashValidity"
                                        style={{ maxWidth: "100%" }}
                                    />
                                </Box>
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#1D53E7",
                                            fontWeight: "600",
                                            fontStyle: "italic",
                                            fontFamily: "Roboto Flex",
                                        }}
                                    >
                                        Validity
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: "600",
                                            fontFamily: "Sofia Sans Extra Condensed",
                                        }}
                                    >
                                        {/* {formattedDate} */}
                                        <Stack
                                            direction="row"
                                            justifyContent="center"
                                            divider={<Box sx={{ mx: { xs: 1, sm: 1.5 } }}>:</Box>}
                                        >
                                            <Stack direction="row" divider={<Box>:</Box>}>
                                                <TimeBlock value={isNaN(days) ? '00' : days} />
                                                <TimeBlock value={isNaN(hours) ? '00' : hours} />
                                                <TimeBlock value={isNaN(minutes) ? '00' : minutes} />
                                                <TimeBlock value={isNaN(seconds) ? '00' : seconds} />
                                            </Stack>
                                        </Stack>
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        component='a'
                                        href='#'
                                        sx={{ color: "#1D53E7", fontFamily: "Roboto Flex" }}
                                    >
                                        {/* {formattedDate !== "-" ? (isActive ? `${daysLeft} Days Left` : "Expired") : null} */}
                                        Buy Now
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>

                </Container>}
            {userDetails?.subscription_status === "Active" ?
                <YourRecentActivity chartData={chartData} /> :
                <Box sx={{ p: 2, mt: { xs: 0, md: 3 }, backgroundColor: '#F1F1F1', borderRadius: 5, width: 'auto', height: { xs: '657px', md: '532px' }, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <Stack direction='column'  >
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            textAlign="center"
                            sx={{
                                color: '#1E53E8',
                                fontSize: { xs: '28px', md: '38px' },
                                fontFamily: 'Sofia Sans Extra Condensed',
                                fontWeight: '700',
                                lineHeight: { xs: '30px', md: '40px' },
                                wordWrap: 'break-word',
                                textTransform: "uppercase",
                            }}
                            gutterBottom
                        >
                            Create your own <br /> megaconnect cloud computer
                        </Typography>
                        <Grid
                            container
                            item
                            justifyContent="center"
                            md={12}
                        >
                            <CreateNew
                                // onClick={}
                                variant="contained"
                                fullWidth
                                size="large"
                                sx={{
                                    color: "#1E53E8",
                                    fontWeight: "bold",
                                    background: "#C7F760",
                                    padding: 1,
                                    borderRadius: 2,
                                }}
                            >
                                Create New
                            </CreateNew>
                        </Grid>
                    </Stack>
                </Box>}


        </Fragment>
    )
}

DashHomeNotActiveUser.propTypes = {
    userDetails: PropTypes.object,
};



// ----------------------------------------------------------------------

function TimeBlock({ label, value }) {
    return (
        <div>
            <Box> {value} </Box>
            <Box sx={{ color: 'text.secondary', typography: 'body1' }}>{label}</Box>
        </div>
    );
}

TimeBlock.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
};
